<template>
  <b-card no-body>
    <!-- <b-card-header>Customisation</b-card-header> -->
    <b-card-body class="p-0 mt-3">
      <b-overlay :show="loading" rounded="sm">
        <b-form>
          <b-row class="mt-2">
            <b-col cols="4" md="4" lg="4">
              <h4 class="font-resize">
                {{ $translate("generic_title") }}
              </h4>
            </b-col>
            <b-col cols="5" sm="6">
              <h4 class="font-resize">
                {{ $translate("customised_title") }}
              </h4> </b-col
            ><b-col cols="3" sm="2">
              <h4 class="font-resize">
                {{ $translate("required") }}
              </h4>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="4">
              <label id="group-bundled-product" for="input-bundled-product">{{
                $translate("primary_product")
              }}</label>
            </b-col>
            <b-col cols="6"
              ><b-form-input
                id="input-bundled-product"
                v-model="settingsData.primary_product"
              ></b-form-input> </b-col
            ><b-col cols="2"></b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="4"
              ><label
                id="group-secondary_items_closing_balances"
                for="input-secondary_items_closing_balances"
                >{{ $translate("secondary_items_balances") }}</label
              ></b-col
            >
            <b-col cols="6"
              ><b-form-input
                id="input-secondary_items_closing_balances"
                v-model="settingsData.secondary_items_closing_balances"
              ></b-form-input> </b-col
            ><b-col cols="2">
              <div class="form-check me-2">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    id="checkbox-secondary_items_closing_balances"
                    v-model="switches.secondary_items_closing_balances"
                    name="checkbox-secondary_items_closing_balances"
                    :value="true"
                    :unchecked-value="false"
                  />
                  <i class="input-helper"></i>
                </label>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="4"
              ><label
                id="group-sub_product_totals_by_size"
                for="input-sub_product_totals_by_size"
                >{{ $translate("sub_products_totals_by_size") }}</label
              ></b-col
            >
            <b-col cols="6"
              ><b-form-input
                id="input-sub_product_totals_by_size"
                v-model="settingsData.sub_product_totals_by_size"
              ></b-form-input> </b-col
            ><b-col cols="2">
              <div class="form-check me-2">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    id="checkbox-sub_product_totals_by_size"
                    v-model="switches.sub_product_totals_by_size"
                    name="checkbox-sub_product_totals_by_size"
                    :value="true"
                    :unchecked-value="false"
                  />
                  <i class="input-helper"></i>
                </label>
              </div>
            </b-col>
          </b-row>

          <b-row
            class="mt-2"
            v-for="(heading, idx) in headings"
            :key="idx + 'heading'"
          >
            <b-col cols="4"
              ><label id="fieldset-horizontal" :for="`input-${idx}`">{{
                $translate(heading)
              }}</label></b-col
            >
            <b-col cols="6"
              ><b-form-input
                :id="`input-${idx}`"
                v-model="settingsData[heading]"
              ></b-form-input> </b-col
            ><b-col cols="2">
              <div class="form-check me-2">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    :id="`checkbox-${heading}`"
                    v-model="switches[heading]"
                    :name="`checkbox-${heading}`"
                    :value="true"
                    :unchecked-value="false"
                  />
                  <i class="input-helper"></i>
                </label>
              </div>
              <!-- <b-form-checkbox></b-form-checkbox> -->
            </b-col>
          </b-row>

          <b-row class="mt-2" v-if="isBundled"
            ><b-col cols="4">
              <label>{{ $translate("bundled_display_type") }}</label>
            </b-col>
            <b-col class="d-flex">
              <div
                class="form-check me-2"
                v-for="(item, idx) in bundledDisplayOptions"
                :key="'settingsData' + idx"
              >
                <label class="form-check-label">
                  <input
                    type="radio"
                    class="form-check-input"
                    name="radio-inline"
                    v-model="settingsData.primary_product_type"
                    :value="item.value"
                  />
                  {{ item.text }}
                  <i class="input-helper"></i>
                </label>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-4"
            ><b-col cols="12" class="text-center">
              <b-button
                variant="blue-button"
                @click="$emit('update-configuration')"
              >
                <b-icon
                  v-if="loading"
                  icon="arrow-clockwise"
                  class="fa-spin"
                  animation="spin"
                ></b-icon>
                <span v-else>{{ $updateLabel() }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import { capitalCase } from "change-case";
import popupMixins from "@/mixins/popupMixins";

export default {
  name: "DailyUsageSettings",
  mixins: [popupMixins],
  data() {
    return {};
  },
  filters: {
    formatTitle(val) {
      return capitalCase(val);
    },
  },

  props: {
    headings: {
      type: Array,
      require: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isBundled: {
      type: Boolean,
      default: false,
    },
    usageSettingsData: { type: Object, default: () => ({}) },
    usageSwitches: { type: Object, default: () => ({}) },
  },
  computed: {
    bundledDisplayOptions() {
      return [
        { text: this.$translate("primary_products"), value: "primary" },
        { text: this.$translate("both_products"), value: "both" },
      ];
    },
    settingsData: {
      get: function () {
        return this.usageSettingsData;
      },

      set: function (newValue) {
        this.$emit("update-settings", newValue);
      },
    },
    switches: {
      get: function () {
        return this.usageSwitches;
      },

      set: function (newValue) {
        this.$emit("update-switches", newValue);
      },
    },
  },

  watch: {},

  methods: {},
};
</script>

<style></style>
